var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-view"},[_c('div',{staticClass:"calendar-control-row"},[_c('div',{staticClass:"calendar-header previous"},[_c('Icon',{attrs:{"size":"18"},on:{"click":_vm.moveToPreviousMonth}},[_vm._v("arrow_back")]),_c('h4',[_vm._v(_vm._s(((_vm.previousMonth.month) + " " + (_vm.previousMonth.year))))])],1),_c('div',{class:[
        'calendar-header',
        'current',
        { disabled: _vm.shouldDisableNextMonth } ]},[_c('h4',[_vm._v(_vm._s(((_vm.currentMonth.month) + " " + (_vm.currentMonth.year))))]),_c('Icon',{attrs:{"size":"18"},on:{"click":_vm.moveToNextMonth}},[_vm._v("arrow_forward")])],1)]),_c('div',{staticClass:"multiple-calendars"},[_c('div',{staticClass:"calendar previous"},[_c('div',{staticClass:"day-names"},_vm._l((_vm.days),function(day){return _c('span',{key:day},[_vm._v(_vm._s(day))])}),0),_c('div',{staticClass:"dates",on:{"mouseleave":function($event){return _vm.setActiveHover(null)}}},_vm._l((_vm.previousMonth.days),function(item,index){return _c('span',{key:index,class:[
            { active: _vm.userDateStart ? item.time === _vm.userDateStart : false },
            { end: _vm.userDateEnd ? item.time === _vm.userDateEnd : false },
            {
              'in-range':
                _vm.userDateStart && !_vm.userDateEnd && _vm.activeHoverItem
                  ? item.time <= _vm.activeHoverItem.time &&
                    item.time >= _vm.userDateStart
                  : false,
            },
            {
              'in-range':
                _vm.userDateStart &&
                _vm.userDateEnd &&
                item.time > _vm.userDateStart &&
                item.time < _vm.userDateEnd,
            },
            {
              'single-date':
                _vm.userDateStart && _vm.userDateEnd && _vm.userDateStart === _vm.userDateEnd
                  ? true
                  : false,
            },
            { disabled: _vm.max && item.time > _vm.max ? true : false } ],style:({
            gridColumnStart:
              index === 0 ? ("" + (_vm.previousMonth.days[0].day + 1)) : "auto",
          }),on:{"click":function($event){return _vm.dateClicked(item)},"mouseenter":function($event){return _vm.setActiveHover(item)}}},[_vm._v(_vm._s(item.date))])}),0)]),_c('div',{staticClass:"calendar current"},[_c('div',{staticClass:"day-names"},_vm._l((_vm.days),function(day){return _c('span',{key:day},[_vm._v(_vm._s(day))])}),0),_c('div',{staticClass:"dates"},_vm._l((_vm.currentMonth.days),function(item,index){return _c('span',{key:index,class:[
            { active: _vm.userDateStart ? item.time === _vm.userDateStart : false },
            { end: _vm.userDateEnd ? item.time === _vm.userDateEnd : false },
            {
              'in-range':
                _vm.userDateStart && !_vm.userDateEnd && _vm.activeHoverItem
                  ? item.time <= _vm.activeHoverItem.time &&
                    item.time >= _vm.userDateStart
                  : false,
            },
            {
              'in-range':
                _vm.userDateStart &&
                _vm.userDateEnd &&
                item.time > _vm.userDateStart &&
                item.time < _vm.userDateEnd,
            },
            {
              'single-date':
                _vm.userDateStart && _vm.userDateEnd
                  ? item.time === _vm.userDateStart && item.time === _vm.userDateEnd
                  : false,
            },
            { disabled: _vm.max && item.time > _vm.max ? true : false } ],style:({
            gridColumnStart:
              index === 0 ? ("" + (_vm.currentMonth.days[0].day + 1)) : "auto",
          }),on:{"click":function($event){return _vm.dateClicked(item)},"mouseenter":function($event){return _vm.setActiveHover(item)}}},[_vm._v(_vm._s(item.date))])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }